import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
};
export const authMutationType = vuexEventPathGenerator(mutationType, 'auth');
const mutations = {
    [mutationType.SET_ACCESS_TOKEN]: (state, accessToken) => { state.accessToken = accessToken; },
};
export default mutations;
